import * as React from 'react';

import { PlaceListDataService } from 'src/app/general/places/list/place-list.data';
import { PlaceEditorView } from './place-editor.view';

export enum PlaceType { General, Airport, Resort, TransferPoint, CoachPickupPoint }

interface PlaceEditorControllerProps {
	value: number | number[] | null;
	multi?: boolean;
	mode: ControlMode;
	onChanged: (value: PlaceSummary) => void;
	setBusy(isBusy: boolean);
	label?: string;
	required?: boolean;
	regionId?: number;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	type?: PlaceType[];
}

export class PlaceEditorController extends React.Component<PlaceEditorControllerProps, {}> {
	protected placeDataService: PlaceListDataService;

	constructor(props) {
		super(props);
		this.placeDataService = PlaceListDataService.make();
	}

	placeQuery = (q?: string): Promise<QueryResult<PlaceSummary>> => {
		return new Promise<QueryResult<PlaceSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.placeDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.type != null) {
				this.placeDataService.addFilter('type', 'in', this.props.type);
			}
			this.placeDataService.addSorting('id', 'asc', true);
			this.placeDataService.searchKeywords = q;
			this.placeDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.placeDataService.count
					});
				});
		});
	};

	render() {
		return (
			<PlaceEditorView
				multi={this.props.multi}
				placeRequest={{ query: this.placeQuery, dataSet: this.placeDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				onGetErrorMessage={this.props.onGetErrorMessage}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
				regionId={this.props.regionId}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/places/parts/place-editor.controller.tsx